import script from "./AlarmDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AlarmDetail.vue?vue&type=script&setup=true&lang=js"

import "./AlarmDetail.vue?vue&type=style&index=0&id=0496b729&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0496b729"]])

export default __exports__